import Router from '../core'
import store from '@/$plugins/store/core'

Router.beforeResolve((to, from, next) => {
    store.commit('gui/setSearchEntityKey')
    next()
})
